import { req } from '../../@api/request';

export default class SearchService {
  static search = async (search: string) => {
    const result = await req.get(`/search?search=${search}`);
    return result.data;
  };
}
